import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'

import auth from './modules/auth'
import assigned from './modules/assigned'

import user from './modules/user'
import category from './modules/category'
import customer from './modules/customer'
import company from './modules/company'
import companyInfo from './modules/settings/company-info'
import dashboard from './modules/dashboard'
import estimate from './modules/estimate'
import expense from './modules/expense'
import invoice from './modules/invoice'
import userProfile from './modules/settings/user-profile'
import payment from './modules/payment'
import preferences from './modules/settings/preferences'
import item from './modules/item'
import modal from './modules/modal'
import currency from './modules/currency'
import general from './modules/settings/general'
import taxType from './modules/tax-type'
import profitLossReport from './modules/reports/profit-loss'
import salesReport from './modules/reports/sales'
import ExpensesReport from './modules/reports/expense'
import TaxReport from './modules/reports/tax'
import CurrentCustomer from './modules/current-customer'
import treasuryAccounts from './modules/treasury'
import calendar from './modules/calendar'
import retenciones from './modules/retenciones'
import prodServ from './modules/prod-serv'
import conceptCategories from './modules/concept-category'
import catalogs from './modules/catalogs'
import rateTables from './modules/rate_tables'
import generalPublicInvoice from './modules/general-public-invoice'
import taxReturns from './modules/tax-returns'
import invoiceManual from './modules/invoice-manual'
import taxLossAndBalance from './modules/tax-loss-balance'
import statementAccount from './modules/statement_account'
import downloadCfdi from './modules/download-cfdi'


// Customer modules
import customerModuleUser from './customer_modules/user'
import customerTaxReturns from './customer_modules/tax_returns'
Vue.use(Vuex)

const initialState = {
  isAppLoaded: false
}

export default new Vuex.Store({
  strict: true,
  state: initialState,
  getters,
  mutations,
  actions,

  modules: {
    auth,
    assigned,
    user,
    category,
    company,
    companyInfo,
    customer,
    dashboard,
    estimate,
    item,
    invoice,
    expense,
    modal,
    userProfile,
    currency,
    payment,
    preferences,
    general,
    taxType,
    profitLossReport,
    salesReport,
    ExpensesReport,
    TaxReport,
    CurrentCustomer,
    treasuryAccounts,
    calendar,
    retenciones,
    prodServ,
    conceptCategories,
    catalogs,
    rateTables,
    generalPublicInvoice,
    taxReturns,
    taxLossAndBalance,
    invoiceManual,
    statementAccount,
    // Customer modules
    customerModuleUser,
    customerTaxReturns,
    downloadCfdi
  },
})
